import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Visita/getDeleteSeleccionVisita  `, method: 'POST', body: {list}, token: token})
}
